export interface TimeSeriesResponseDto {
    metrics: {
        value: string;
        allTimeAverage: string;
        max: string;
        weekdayAverage: string;
        deviationFromAveragePercentage: string;
        allTimeAverageLine: number;
    }
    data: TimeSeriesData[]
}
  
export interface TimeSeriesData {
    date: string,
    value: number;
}